import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function ImageGallery() {
  const { t } = useTranslation();
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const images = [
    {
      label: t('gallery.image1.label'),
      caption: t('gallery.image1.caption'),
      gradient: 'from-rose-500/10 to-pink-500/10',
      image: 'https://static.readdy.ai/image/584ac40951726429431482b4d17e4edf/87eff827d8210876936adf797550444e.jpeg'
    },
    {
      label: t('gallery.image2.label'),
      caption: t('gallery.image2.caption'),
      gradient: 'from-teal-500/10 to-cyan-500/10',
      image: 'https://static.readdy.ai/image/584ac40951726429431482b4d17e4edf/4998c0fa9a33cdba68f9ce6a3d4fa429.jpeg'
    },
    {
      label: t('gallery.image3.label'),
      caption: t('gallery.image3.caption'),
      gradient: 'from-emerald-500/10 to-teal-500/10',
      image: 'https://static.readdy.ai/image/584ac40951726429431482b4d17e4edf/473db250e1513f6c65d66be48efcf3b4.png'
    }
  ];

  return (
    <>
      <section className="relative py-32 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8">
            {images.map((image, index) => (
              <div 
                key={index}
                className="space-y-4"
              >
                <div 
                  onClick={() => image.image && setSelectedImage(image.image)}
                  className={`relative aspect-square rounded-2xl ${image.image ? 'overflow-hidden cursor-pointer' : `bg-gradient-to-br ${image.gradient} border border-slate-700/50 backdrop-blur-sm flex items-center justify-center overflow-hidden`} transition-all duration-300 hover:scale-105`}
                >
                  {image.image ? (
                    <img 
                      src={image.image}
                      alt={image.label}
                      className="w-full h-full object-cover object-top"
                    />
                  ) : (
                    <>
                      <div className="absolute inset-0 bg-slate-900/30"></div>
                      <div className="relative text-center space-y-4 p-8">
                        <div className="w-20 h-20 mx-auto flex items-center justify-center">
                          <i className="ri-image-line text-6xl text-slate-600"></i>
                        </div>
                        <p className="text-slate-500 font-medium">{image.label}</p>
                      </div>
                    </>
                  )}
                </div>
                <p className="text-slate-400 text-sm leading-relaxed text-center px-2">
                  {image.caption}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div 
          onClick={() => setSelectedImage(null)}
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4 cursor-pointer"
        >
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-6 right-6 w-12 h-12 flex items-center justify-center text-white hover:bg-white/10 rounded-full transition-colors cursor-pointer"
          >
            <i className="ri-close-line text-3xl"></i>
          </button>
          <img 
            src={selectedImage}
            alt="Full size view"
            className="max-w-full max-h-full object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </>
  );
}